import { Button, Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { formatUnits } from "viem";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";
import { ShieldingCard } from "./ShieldingCard";
import type { ShieldingFormData } from "./shieldingConfig";

export function ShieldingReviewModal({
  isOpen,
  onClose,
  shieldingFormData,
  onShield,
}: {
  isOpen: boolean;
  onClose: () => void;
  shieldingFormData: ShieldingFormData | null;
  onShield: () => void;
}) {
  if (!shieldingFormData) {
    return null;
  }

  const publicBalancesAfterTransaction =
    shieldingFormData.shieldingMode === "shield"
      ? formatUnits(shieldingFormData.publicBalance - shieldingFormData.amount, shieldingFormData.tokenDecimals)
      : formatUnits(shieldingFormData.publicBalance + shieldingFormData.amount, shieldingFormData.tokenDecimals);
  const privateBalancesAfterTransaction =
    shieldingFormData.shieldingMode === "shield"
      ? formatUnits(shieldingFormData.privateBalance + shieldingFormData.amount, shieldingFormData.tokenDecimals)
      : formatUnits(shieldingFormData.privateBalance - shieldingFormData.amount, shieldingFormData.tokenDecimals);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalHeader>Confirm {shieldingFormData.shieldingMode === "shield" ? "Shielding" : "Unshielding"}</ModalHeader>

        <ModalBody>
          <ShieldingCard
            shieldingMode={shieldingFormData.shieldingMode}
            tokenSymbol={shieldingFormData.tokenSymbol}
            displayAmount={shieldingFormData.displayAmount}
          />

          <div className="bg-[#3F6784] rounded-xl p-4 w-full">
            <div className="mb-2 font-semibold">Balances after transaction</div>
            <div className="w-full space-y-1">
              <div className="flex items-center justify-between">
                <div className="text-[#ADC0D0]">Public (Unshielded)</div>
                <div className="font-semibold">
                  {publicBalancesAfterTransaction} {shieldingFormData.tokenSymbol}
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="text-[#ADC0D0]">Private (Shielded)</div>
                <div className="font-semibold">
                  {privateBalancesAfterTransaction} {shieldingFormData.tokenSymbol}
                </div>
              </div>
            </div>
          </div>

          <div className="w-full space-y-3">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type="public" />
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Gas fees</div>
              <div className="font-semibold">0.00005 ETH</div>
            </div>
          </div>

          <Button
            fullWidth
            radius="full"
            size="lg"
            color="primary"
            className="font-semibold text-large h-16"
            onPress={onShield}
          >
            {shieldingFormData.shieldingMode === "shield" ? "Shield" : "Unshield"}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
